/* ============================================================
   ELEMENTA · Traducciones de la pagina de Rivo Loyalty
   ------------------------------------------------------------
   POR QUE EXISTE:
   Rivo deja varios textos en ingles ("Redeem", "Points", "Spent",
   "Expires At"...) y en el panel de la app (Branding > Translation)
   no se pudieron cambiar. Este archivo los traduce desde el tema.

   COMO FUNCIONA (2 capas):

   1) STORE DE ALPINE  <- via principal, sin parpadeo.
      La app guarda sus textos en `RivoAlpine.store('rivo_lp_translation')`
      y pinta con `rivo-x-text`. Alpine es REACTIVO: al escribir en el
      store, la vista se actualiza sola. Se intenta antes de que pinte.

   2) REEMPLAZO EN EL DOM  <- red de seguridad.
      Para textos que no salen del store (los inyecta el HTML de la app
      o un widget aparte). Solo toca nodos de texto sueltos: nunca
      reescribe HTML, asi que no puede romper los botones ni sus eventos.

   TODO ESTO SOLO CORRE EN LA PAGINA DE LOYALTY.
   Si algun dia se pueden cambiar en el panel de Rivo, se puede borrar
   este archivo y su <script> en theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  var SUFFIX = 'template-suffix-rivo-loyalty-landing-page';
  if (!document.body || document.body.className.indexOf(SUFFIX) === -1) return;

  /* ------------------------------------------------------------
     Traducciones por CLAVE (capa 1)
     Para editar un texto, cambia el valor de la derecha.
     ------------------------------------------------------------ */
  var CLAVES = {
    loyalty_page_general_redeem: 'Canjear',
    loyalty_page_general_points: 'Puntos',
    loyalty_page_general_spent:  'Gastados',
    loyalty_page_activity_table_header_expiration: 'Vence el',
    general_apply_code_now: 'Aplicar código ahora',
    general_discount_code_applied_to_cart: 'Descuento aplicado a tu carrito'
  };

  /* ------------------------------------------------------------
     Traducciones por TEXTO VISIBLE (capa 2)
     El orden importa: las frases largas van primero, para que no
     se traduzca una palabra suelta dentro de una frase mas larga.
     ------------------------------------------------------------ */
  var TEXTOS = [
    ['Earn points and turn these into rewards!', 'Gana puntos y conviértelos en recompensas'],
    ['Earn points and turn these into rewards',  'Gana puntos y conviértelos en recompensas'],
    ['Join and Earn Rewards', 'Únete y gana recompensas'],
    ['Already a member?',     '¿Ya tienes cuenta?'],
    ['Start Earning',         'Empezar a ganar'],
    ['Apply code now',        'Aplicar código ahora'],
    ['Expires At',            'Vence el'],
    ['Redeem',                'Canjear'],
    ['Points',                'Puntos'],
    ['Spent',                 'Gastados']
  ];

  /* ============================================================
     CAPA 1 · Escribir en el store de Alpine
     ============================================================ */
  var storeListo = false;

  function aplicarStore() {
    try {
      var A = window.RivoAlpine;
      if (!A || typeof A.store !== 'function') return false;
      var st = A.store('rivo_lp_translation');
      if (!st) return false;
      for (var k in CLAVES) {
        if (Object.prototype.hasOwnProperty.call(CLAVES, k)) st[k] = CLAVES[k];
      }
      /* Algunas vistas leen del store general */
      var g = A.store('rivo_general_translation');
      if (g) {
        if (g.general_points) g.general_points = CLAVES.loyalty_page_general_points;
        if (g.general_redeem) g.general_redeem = CLAVES.loyalty_page_general_redeem;
      }
      storeListo = true;
      return true;
    } catch (e) { return false; }
  }

  /* Reintenta hasta que Alpine exista (la app carga async) */
  var intentos = 0;
  var t = setInterval(function () {
    if (aplicarStore() || ++intentos > 60) clearInterval(t);
  }, 100);
  aplicarStore();

  /* ============================================================
     CAPA 2 · Reemplazo en nodos de texto
     Solo toca TEXTO, nunca HTML: no puede romper botones ni eventos.
     ============================================================ */
  var SALTAR = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1 };

  /* Comprueba que el caracter no sea parte de una palabra */
  function esLetra(c) {
    return !!c && /[A-Za-z0-9_]/.test(c);
  }

  /* Reemplaza solo ocurrencias que sean palabra completa. */
  function reemplazarPalabra(texto, de, a) {
    var salida = "", i = 0;
    while (true) {
      var p = texto.indexOf(de, i);
      if (p === -1) { salida += texto.slice(i); break; }
      var antes = p > 0 ? texto.charAt(p - 1) : "";
      var desp  = texto.charAt(p + de.length);
      if (esLetra(antes) || esLetra(desp)) {
        salida += texto.slice(i, p + de.length);
      } else {
        salida += texto.slice(i, p) + a;
      }
      i = p + de.length;
    }
    return salida;
  }

  function traducirNodo(nodo) {
    var orig = nodo.nodeValue;
    if (!orig || !orig.trim()) return;
    var nuevo = orig;
    for (var i = 0; i < TEXTOS.length; i++) {
      if (nuevo.indexOf(TEXTOS[i][0]) === -1) continue;
      nuevo = reemplazarPalabra(nuevo, TEXTOS[i][0], TEXTOS[i][1]);
    }
    if (nuevo !== orig) nodo.nodeValue = nuevo;
  }

  function recorrer(raiz) {
    if (!raiz) return;
    if (raiz.nodeType === 3) { traducirNodo(raiz); return; }
    if (raiz.nodeType !== 1) return;
    if (SALTAR[raiz.tagName]) return;
    var it = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return (n.parentNode && SALTAR[n.parentNode.tagName])
          ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var n, lista = [];
    while ((n = it.nextNode())) lista.push(n);
    for (var i = 0; i < lista.length; i++) traducirNodo(lista[i]);
  }

  function pasada() {
    var zona = document.querySelector('.rivo-lp-section, #rivo-loyalty-page, .rivo-content-wrapper');
    recorrer(zona || document.body);
    /* Los modales viven fuera de la zona principal */
    var mods = document.querySelectorAll('.rivo-modal');
    for (var i = 0; i < mods.length; i++) recorrer(mods[i]);
  }

  /* Primera pasada cuando el DOM este listo */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pasada);
  } else {
    pasada();
  }

  /* La app repinta con JS: se vuelve a pasar cuando cambie el DOM.
     Se agrupa con requestAnimationFrame para no trabajar de mas. */
  var pendiente = false;
  var obs = new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; pasada(); });
  });
  try {
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  } catch (e) {}

  /* NO se desconecta el observer.
     Motivo: los modales y la tabla de actividad se pintan cuando el
     usuario interactua (abrir una recompensa, "mostrar mas"), mucho
     despues de cargar la pagina. Con un limite de tiempo, esos textos
     se quedaban en ingles — era el caso de "Spent 400 Points".
     El coste es minimo: la pasada esta agrupada con requestAnimationFrame
     y solo recorre nodos de texto dentro de la zona de Rivo. */

  /* Ademas, la app CALCULA la descripcion una sola vez y la guarda
     (`Spent 400 Points` sale de concatenar 3 valores del store).
     Si nuestro store llega tarde, ese texto ya quedo fijo; por eso la
     capa 2 tiene que seguir viva. */
  document.addEventListener('click', function () {
    setTimeout(pasada, 60);
    setTimeout(pasada, 350);
  }, true);

  /* ============================================================
     CAPA 3 · Traducir los textos YA CALCULADOS de la app

     La app arma la descripcion de cada recompensa concatenando valores
     del store y la GUARDA en `reward.description`:
         `${spent} ${n} ${points}`  ->  "Spent 400 Points"
     Ese texto se calcula UNA vez. Si nuestro store llega despues, el
     valor ya quedo fijo y traducir el store no lo cambia — por eso
     "200 Points" seguia en ingles.

     Aqui se recorren las colecciones del store y se traduce el texto
     ya guardado, en su origen.
     ============================================================ */
  function traducirTexto(t) {
    if (typeof t !== 'string' || !t) return t;
    var r = t;
    for (var i = 0; i < TEXTOS.length; i++) {
      if (r.indexOf(TEXTOS[i][0]) === -1) continue;
      r = reemplazarPalabra(r, TEXTOS[i][0], TEXTOS[i][1]);
    }
    return r;
  }

  function traducirColecciones() {
    try {
      var A = window.RivoAlpine;
      if (!A || typeof A.store !== 'function') return;

      /* Campos de texto que la app deja pre-calculados */
      var CAMPOS = ['description', 'pretty_points_tally', 'name',
                    'pretty_applied_at_with_text', 'title'];

      function limpiar(obj) {
        if (!obj || typeof obj !== 'object') return;
        for (var i = 0; i < CAMPOS.length; i++) {
          var c = CAMPOS[i];
          if (typeof obj[c] === 'string') {
            var n = traducirTexto(obj[c]);
            if (n !== obj[c]) obj[c] = n;
          }
        }
      }

      function recorrerLista(lista) {
        if (!Array.isArray(lista)) return;
        for (var i = 0; i < lista.length; i++) {
          limpiar(lista[i]);
          if (lista[i] && lista[i].reward) limpiar(lista[i].reward);
        }
      }

      var cust = A.store('customer');
      if (cust) {
        recorrerLista(cust.points_purchases);
        recorrerLista(cust.rewards);
        recorrerLista(cust.unused_rewards);
        recorrerLista(cust.points_logs);
      }
      var cfg = A.store('loy_config');
      if (cfg) {
        recorrerLista(cfg.rewards);
        recorrerLista(cfg.ways_to_earn);
        recorrerLista(cfg.ways_to_redeem);
      }
    } catch (e) {}
  }

  /* Se corre junto con cada pasada del DOM */
  var pasadaDOM = pasada;
  pasada = function () { traducirColecciones(); pasadaDOM(); };

  /* Y en los primeros segundos, mientras la app carga sus datos */
  var reintentosCol = 0;
  var tc = setInterval(function () {
    traducirColecciones();
    if (++reintentosCol > 40) clearInterval(tc);
  }, 150);

  /* Utilidad de diagnostico */
  window.ELEMENTA_RIVO_TEXTOS = {
    claves: CLAVES,
    textos: TEXTOS,
    storeAplicado: function () { return storeListo; },
    reaplicar: function () { aplicarStore(); pasada(); return 'listo'; }
  };
})();
